import { Box, Typography, Button } from "@mui/material";
import {
  StarBorder as StarBorderIcon,
  Folder as FolderIcon,
  Star as StarIcon,
} from "@mui/icons-material";

export const EmptyDirectoryComponent = ({
  searchQuery,
  showFavoritesOnly,
  handleFavoritesClick,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        {showFavoritesOnly && (
          <>
            <StarBorderIcon sx={{ fontSize: 64, color: "#E5E7EB", mb: 1 }} />
            <Typography
              variant="h6"
              sx={{
                color: "#212121",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 600,
                mb: 0.5,
              }}
            >
              No favorites yet
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#4A5565",
                fontFamily: "Roboto, sans-serif",
                mb: 3,
                maxWidth: 400,
                textAlign: "center",
              }}
            >
              Click the star icon next to files or folders to add them to
              favorites
            </Typography>
            <Button
              variant="outlined"
              onClick={handleFavoritesClick}
              sx={{
                textTransform: "none",
                fontFamily: "Roboto, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                color: "#2932E5",
                borderColor: "#2932E5",
                borderRadius: "10px",
                padding: "5px 15px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderImage: "initial",
                transition:
                  "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                borderColor: "#2932E5",
                "&:hover": {
                  borderColor: "#2932E5",
                  bgcolor: "rgba(41, 50, 229, 0.04)",
                },
              }}
              startIcon={<StarIcon />}
            >
              Browse all files
            </Button>
          </>
        )}

        {!showFavoritesOnly && (
          <>
            <FolderIcon sx={{ fontSize: 64, color: "text.disabled" }} />
            <Typography variant="body1" color="text.secondary">
              {searchQuery ? "No files found" : "This folder is empty"}
            </Typography>
          </>
        )}
      </Box>
    </>
  );
};
